'use strict'

const {constants} = require('@wix/santa-core-utils')

const _ = require('lodash')
const {transformations, stripHashIfExists, variantRelation, refArray} = require('../helpers/dataUtils')

const cleanRef = ref => stripHashIfExists(ref)

function moveRotationFromLayoutToTransformation(layout, pageData, getTransformationsUniqueId) {
    const rotationInDegrees = _.get(layout, ['componentLayout', 'rotationInDegrees'])
    pageData.layout_data[layout.id] = _.omit(layout, ['componentLayout.rotationInDegrees'])

    const transformationId = getTransformationsUniqueId()
    const transformation = transformations.createTransformationWithRotate(transformationId, rotationInDegrees)
    pageData.transformations_data = {
        ...pageData.transformations_data,
        [transformationId]: transformation
    }
    return transformationId
}

function moveRotationToTransformations(comps, pageData, getTransformationsUniqueId, magicObject) {
    const layoutData = pageData.layout_data
    _.forEach(comps, comp => {
        if (comp.layoutQuery) {
            const layoutRefArray = layoutData[cleanRef(comp.layoutQuery)]
            const transformationsRefs = []
            if (!layoutRefArray) {
                const {id: compId, layoutQuery} = comp
                magicObject.captureError({
                    errorType: 'MISSING_COMP_LAYOUT',
                    message: 'Component contains a reference to a layout that does not exist',
                    extras: {compId, layoutQuery}
                })
            }
            _.forEach(layoutRefArray.values, value => {
                const layout = layoutData[cleanRef(value)]
                if (layout.componentLayout && layout.componentLayout.rotationInDegrees) {
                    const transformationId = moveRotationFromLayoutToTransformation(
                        layout,
                        pageData,
                        getTransformationsUniqueId
                    )
                    transformationsRefs.push(`#${transformationId}`)
                } else if (variantRelation.isVariantRelation(layout) && layoutData[cleanRef(layout.to)]) {
                    const innerLayout = layoutData[cleanRef(layout.to)]
                    if (innerLayout.componentLayout && innerLayout.componentLayout.rotationInDegrees) {
                        const transformationId = moveRotationFromLayoutToTransformation(
                            innerLayout,
                            pageData,
                            getTransformationsUniqueId
                        )
                        //create transformations variant relation
                        const transformationVariantRelationId = getTransformationsUniqueId()
                        const transformationVariantRelation = variantRelation.create({
                            id: transformationVariantRelationId,
                            variants: layout.variants,
                            from: layout.from,
                            scopedDataId: transformationId
                        })
                        pageData.transformations_data = pageData.transformations_data = {
                            ...pageData.transformations_data,
                            [transformationVariantRelationId]: transformationVariantRelation
                        }
                        transformationsRefs.push(`#${transformationVariantRelationId}`)
                    }
                }
            })
            if (transformationsRefs.length) {
                const transformationsRefArrayId = getTransformationsUniqueId()
                const transformationsRefArray = {
                    id: transformationsRefArrayId,
                    ...refArray.create(transformationsRefs)
                }
                pageData.transformations_data = {
                    ...pageData.transformations_data,
                    [transformationsRefArrayId]: transformationsRefArray
                }
                comp.transformationQuery = transformationsRefArrayId
            }
        }
        if (comp.components) {
            moveRotationToTransformations(comp.components, pageData, getTransformationsUniqueId, magicObject)
        }
        if (comp.children) {
            moveRotationToTransformations(comp.children, pageData, getTransformationsUniqueId, magicObject)
        }
        if (comp.mobileComponents) {
            moveRotationToTransformations(comp.mobileComponents, pageData, getTransformationsUniqueId, magicObject)
        }
    })
}

/**
 * @exports utils/dataFixer/plugins/moveRotationToTransformation
 * @type {{exec: function}}
 */
module.exports = {
    name: 'moveRotationToTransformationFixer',
    version: 1,
    exec(pageJson, pageIdsArray, magicObject) {
        const {dataFixerUtils} = magicObject
        const shouldMigrate = pageJson.data.layout_data
        if (shouldMigrate) {
            const structureData = pageJson.structure
            const pageData = pageJson.data
            const getTransformationsUniqueId = () =>
                dataFixerUtils.uniqueIdGenerator.getUniqueId(constants.DATA_TYPES.transformations, '_')

            if (!structureData) {
                return
            }
            if (structureData.components) {
                moveRotationToTransformations(
                    structureData.components,
                    pageData,
                    getTransformationsUniqueId,
                    magicObject
                )
            }
            if (structureData.children) {
                moveRotationToTransformations(structureData.children, pageData, getTransformationsUniqueId, magicObject)
            }
            if (structureData.mobileComponents) {
                moveRotationToTransformations(
                    structureData.mobileComponents,
                    pageData,
                    getTransformationsUniqueId,
                    magicObject
                )
            }
        }
    }
}
